import { useEffect } from "react";

// Adds <meta name="robots" content="noindex, nofollow"> while a private page is
// mounted, and removes it on unmount. Use on pages that must never be indexed
// (access-token pages, thank-you, admin).
export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);
}

export default useNoIndex;
